import React, { useState, useEffect, useRef } from "react";
import "./VideoSlideshow.css";

const VideoSlideshow = ({ vdeoslideshowf_file_filedata = [], banner_default }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const videoRefs = useRef([]);

  useEffect(() => {
    if (!vdeoslideshowf_file_filedata.length) return;

    const currentVideo = videoRefs.current[currentSlide];

    // Stop all other videos
    videoRefs.current.forEach((video, i) => {
      if (video && i !== currentSlide) {
        video.pause();
        video.currentTime = 0;
      }
    });

    if (currentVideo) {
      currentVideo.currentTime = 0;
      currentVideo
        .play()
        .then(() => {})
        .catch(() => {}); // prevent autoplay errors

      // When video ends, go to next
      const handleEnded = () => {
        const nextIndex =
          currentSlide === vdeoslideshowf_file_filedata.length - 1
            ? 0
            : currentSlide + 1;
        setCurrentSlide(nextIndex);
      };

      currentVideo.addEventListener("ended", handleEnded);

      return () => currentVideo.removeEventListener("ended", handleEnded);
    }
  }, [currentSlide, vdeoslideshowf_file_filedata]);

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  if (!vdeoslideshowf_file_filedata.length) return null;

  return (
    <div className="video-slideshow-container">
      {vdeoslideshowf_file_filedata.map((row, index) => (
        <div
          key={index}
          className={`video-slide ${index === currentSlide ? "active" : ""}`}
        >
          <video
            ref={(el) => (videoRefs.current[index] = el)}
            src={row.url}
            className="video-element"
            muted
            loop={true}
            playsInline 
            preload="auto"
          />
        </div>
      ))}

      {/* Dots */}
      <div className="video-dots">
        {vdeoslideshowf_file_filedata.map((_, index) => (
          <span
            key={index}
            className={`video-dot ${index === currentSlide ? "active" : ""}`}
            onClick={() => handleDotClick(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default VideoSlideshow;
